import { StoreState } from 'state/types';
import { ReloadNotificationReducerState } from './types';

const getState = (state: StoreState): ReloadNotificationReducerState =>
  state.rosterCopyPast.reloadNotification;

export const getReloadNotificationId = (state: StoreState) =>
  getState(state).reloadNotificationId;
